export const workloadPaths = {
  INDEX: '/',
}
